import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { TicketsService, MessageService} from 'src/app/services';
import { CreateTicketFormFields } from 'src/app/models/tickets/createTicketFormFields';
import { BartTicketSave } from 'src/app/models/tickets/bart.ticket.save'
import {  AccessUserInfo } from 'src/app/models';
import { TicketStatus } from 'src/app/enum/ticket/ticket-status.enum';
import { ConfService } from 'src/conf.service';
import { DatePipe } from '@angular/common'
@Component({
  selector: 'bart-ticket-summary',
  templateUrl: './ticket-summary.component.html',
  styleUrls: ['./ticket-summary.component.scss']
})
export class TicketSummaryComponent implements OnInit {
  datePipe = new DatePipe('en-US')
  public styleName:string="";
  public useExistingCss:boolean=true;
  public formFields:CreateTicketFormFields;
  userId:number;
  bartRoleCode:string;
  userName:string
  bartRoleId:number;
  firstLastName:string=""
  public totalTime:number
  public partTotalAmount:number;
  public printTitle:string;
  public yesReleaseEquipRadioButtonShow:boolean=true;
  public noReleaseEquipRadioButtonShow:boolean=true;
  public isTicketClosed:boolean=false;
public ShowAdminVoidDailoge:boolean=false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private _ticketService: TicketsService,
    private router: Router ,
    private _bartTicketSave:BartTicketSave,
    private _messageService:MessageService
  )
  {
    this.formFields=new CreateTicketFormFields()
  
    let userInfo = AccessUserInfo.getUserInfo();
    if(userInfo!=null)
    {
      this.userId=userInfo.userId
      this.bartRoleCode=userInfo.bartRoleCode
      this.userName=userInfo.userName
      this.bartRoleId=userInfo.bartRoleId
      this.firstLastName=userInfo.firstLastName
      // this.firstName=userInfo.firstName;
      // this.lastName=userInfo.lastName;
    }
    
  }

  ngOnInit() {
   
    this._ticketService.getTicketGlobalData().subscribe((Result: any) => {   
      this.formFields=Result;
      this.applyPrintCSSForProductionBuild();
        this.printTitle="Ticket "+this.formFields.ticketNumber
        if(this.formFields.ticketStatusId==TicketStatus.Closed)
        {
          this.formFields.isReleaseEquipRadioDisabled=true
          this.loadTicketParts(this.formFields.TicketId);
          this.calculateTotal();
          this.isTicketClosed=true;
        }
        else
        {
          this.isTicketClosed=false;
          this.calculateTotal();
        }
        this.populateClosedSummary();
     }, 
     (error) => {
       console.log(error);
     }
   );

    if (this.bartRoleCode == 'BOMX' || this.bartRoleCode == 'BOM' || this.bartRoleCode == 'ADMIN') 
    {
        if (this.formFields.ticketStatusId ==TicketStatus.Void) 
        {
          this.formFields.isTSVoidButtonShow=true
        }
    }
    
  }

  public populateClosedSummary() 
  {
    if(this.formFields.ticketSavedByFirstLastName==null || this.formFields.ticketSavedByFirstLastName==undefined || this.formFields.ticketSavedByFirstLastName=="")
      {
        this.formFields.ticketSavedByFirstLastName=this.firstLastName;
      }

    if(this.formFields.ticketStatusId ==TicketStatus.Closed && this.formFields.isEquipmentReleasedForTreatmentFlag==1)
    {
          this.yesReleaseEquipRadioButtonShow=true
          this.noReleaseEquipRadioButtonShow=false
    }
    if(this.formFields.ticketStatusId ==TicketStatus.Closed && this.formFields.isEquipmentReleasedForTreatmentFlag==0)
    {
          this.yesReleaseEquipRadioButtonShow=false
          this.noReleaseEquipRadioButtonShow=true
    }
    if(this.formFields.ticketStatusId ==TicketStatus.Closed)
    {
          this.formFields.isReleaseEquipRadioDisabled=true;
          this.formFields.isTSVoidButtonShow=true;
          this.formFields.btnHideCloseTicketSummary=true
    }
   else
   {
    this.formFields.isTSVoidButtonShow=false;
   }

  }
  public radioButtonClicked()
  {
    if(this.formFields.isEquipmentReleasedForTreatmentFlag && this.formFields.ticketStatusId!=TicketStatus.Closed)
    {
      this.formFields.isTSCloseButtonShow=true;
    }
    else
    {
      this.formFields.isTSCloseButtonShow=false;
    }
  }
  public calculateTotal()
  {
    //Calculate total Time
     let labourTime=Number(this.formFields.hoursWorkedSel+"."+this.formFields.minutesWorkedSel) 
     let travellTime=Number(this.formFields.hoursTravelSel+"."+this.formFields.minutesTravelSel) 
     this.totalTime=Number(labourTime+travellTime);
    //Calculate Total Part Amount
    setTimeout(() => {
      if(this.formFields.partsUsedDuringRepair)
      {
        this.partTotalAmount=this.formFields.partsUsedDuringRepair.map(t => (t.unitCost*t.quantity)).reduce((a, b) => a + b, 0)
        this.partTotalAmount= Number(this.partTotalAmount.toFixed(2))
        this.scrollToBottom()
      }
    }, 0);

    this.applyPrintCSSForProductionBuild();
  }
  public goTo(routeName)
  {
    window.location.href="/"+routeName
  }
  public hasPermission(btnName)
  {
    let result:Boolean=false
    if(btnName=="Dashboard" &&  "ADMIN,BOM,BOMX,BSS,BSSX".split(",").indexOf(this.bartRoleCode)>-1)
    {
      result= true;
      
    }
    if(btnName=="Void" &&  "ADMIN,BOM,BOMX".split(",").indexOf(this.bartRoleCode)>-1)
    {
      result= true;
    }
    return result
  }
  public VoidnonBatchTicketSummary() {
    this.ShowAdminVoidDailoge = true;
  }
  async voidClosedTicketBtn() {
    var voidReason = this.formFields.voidClosedReason;
    // for what's left, let's strip newlines out and see if we end up with nothing
    var voidReasonNoCR = voidReason.replace(/^\s+|\s+$/g, '');

    if (voidReasonNoCR.length == 0) {
      this._messageService.showAlertMessage('You must provide a reason why you\'re voiding this ticket.');
    } else {
     
      var ticketVoided =await this._bartTicketSave.voidClosedTicket();
      
    };
  }
  public closeTicket()
  {
    var CLOSETICKET={
      "CLOSETICKET":
      {
        ticketId: this.formFields.TicketId,
        equipmentId: this.formFields.SelectedEquipmentID,  
        ISEQUIPMENTRELEASEDFORTREATMENTFLAG:this.formFields.isEquipmentReleasedForTreatmentFlag==null?0:this.formFields.isEquipmentReleasedForTreatmentFlag,  // Autorization checked 1 else 0
        clockHours: this.formFields.clockHours,     
        sqaSubCodeId: this.formFields.selectedSQASubCodeId<=0?null:this.formFields.selectedSQASubCodeId,
        sqaCodeId: this.formFields.selectedSQACodeId<=0?null:this.formFields.selectedSQACodeId,
        UserID:this.userId
      } ,
      "USPCREATESERVICEREQUESTFROMTICKET":
      {
        TicketID:this.formFields.TicketId
      }  
    }
    this._ticketService.closeTicket(JSON.stringify(CLOSETICKET)).subscribe((Result: any) => 
    {
      if (Result == null || Result=="" || Result.length==null ) 
      {
        // enable #backToDash,#printTicket,#newTicket
        this.formFields.isTSCommonButtonShow=true;
        this.formFields.isTSCloseButtonShow=false;
        this.formFields.ticketStatusId=TicketStatus.Closed;
        if(this.formFields.ticketStatusId ==TicketStatus.Closed && this.formFields.isEquipmentReleasedForTreatmentFlag==1)
        {
          this.yesReleaseEquipRadioButtonShow=true
          this.noReleaseEquipRadioButtonShow=false
        }
        if(this.formFields.ticketStatusId ==TicketStatus.Closed && this.formFields.isEquipmentReleasedForTreatmentFlag==0)
        {
          this.yesReleaseEquipRadioButtonShow=false
          this.noReleaseEquipRadioButtonShow=true
        }
        if(this.formFields.ticketStatusId ==TicketStatus.Closed)
        {
          this.formFields.isReleaseEquipRadioDisabled=true;
          this.formFields.btnHideCloseTicketSummary=true
        }
      } 
      else 
      {
        this._messageService.showAlertMessage('An error occurred while attempting to close the ticket.');
      }
    },
      (error) => 
      {
        console.log(error)
      }
    );

  }
  public applyPrintCSSForProductionBuild()
  {
    
    this.useExistingCss=true;
    if (ConfService.conf.environment.production) {
      this.useExistingCss = false;
      const elements = document.getElementsByTagName('link');
      for (let index = 0; index < elements.length; index++) {
        console.log(elements[index].href);
        //if (elements[index].href.startsWith(document.baseURI)) {
          this.styleName += elements[index].href + ',';
        //}
      }
      this.styleName = this.styleName.slice(0, -1);
    }
    console.log("Production Build: "+ConfService.conf.environment.production);
    console.log("styleName: "+this.styleName);
    console.log("useExistingCss: "+this.useExistingCss);
    
  }
  public scrollToBottom()
  {
    document.getElementsByClassName('ui-dialog-content')[0].scrollTop =2000;
      return false;
  }

  public loadTicketParts(ticketId) {
    var i = 0;
    var partTotal = 0;
    let getTicketPartsParam =
    {
      "GETTICKETPARTS": {
        TicketID: ticketId
      }
    }
    this._ticketService.getTicketParts(JSON.stringify(getTicketPartsParam)).subscribe(data => {
      if (data != null && data.length > 0) {
        this.formFields.partsUsedDuringRepair = data.filter
          (
            (thing, i, arr) => arr.findIndex(t => t.PartID === thing.PartID) === i
          ).
          map(data => ({
            quantity: data.Quantity,
            partId: data.PartID,
            partNumber: data.PartNumber,
            manufacturerName: data.manufacturerName,
            partDescription: data.partDescription,
            originalUnitCost: data.OriginalUnitCost,
            unitCost: data.UnitCost,
            dateOfInstall: this.datePipe.transform(data.DateOfInstall, "MM/dd/yyyy"),
            isPartUnderWarranty: 0,
            rgaNumber: data.RGANumber,
            showRgaOptions: 1,//set this properly, at a later date -CH
            ticketPartSourceId: data.TicketPartSourceID,
            isReplacingWarrantyPartFlag: data.isReplacingWarrantyPartFlag,
            isRGAQualifiedFlag: data.isRGAQualifiedFlag,
            zeroCost: null,
          }));
        this.calculateTotal();
      }
    },
      (error) => {
        console.log(error);
      }
    )
  }
}
